export default function ModeSunIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M250,354.39c-57.56,0-104.39-46.83-104.39-104.39s46.83-104.39,104.39-104.39,104.39,46.83,104.39,104.39-46.83,104.39-104.39,104.39ZM250,167.61c-45.43,0-82.39,36.96-82.39,82.39s36.96,82.39,82.39,82.39,82.39-36.96,82.39-82.39-36.96-82.39-82.39-82.39Z" />
      <path d="M250,122.62c-6.08,0-11-4.92-11-11v-24.62c0-6.08,4.92-11,11-11s11,4.92,11,11v24.62c0,6.08-4.92,11-11,11Z" />
      <path d="M250,424c-6.08,0-11-4.92-11-11v-24.62c0-6.08,4.92-11,11-11s11,4.92,11,11v24.62c0,6.08-4.92,11-11,11Z" />
      <path d="M347.85,163.15c-2.81,0-5.63-1.07-7.78-3.22-4.3-4.3-4.3-11.26,0-15.56l17.41-17.41c4.3-4.29,11.26-4.29,15.56,0s4.3,11.26,0,15.56l-17.41,17.41c-2.15,2.15-4.96,3.22-7.78,3.22Z" />
      <path d="M134.74,376.26c-2.81,0-5.63-1.07-7.78-3.22-4.3-4.3-4.3-11.26,0-15.56l17.41-17.41c4.3-4.29,11.26-4.29,15.56,0s4.3,11.26,0,15.56l-17.41,17.41c-2.15,2.15-4.96,3.22-7.78,3.22Z" />
      <path d="M413,261h-24.62c-6.08,0-11-4.92-11-11s4.92-11,11-11h24.62c6.08,0,11,4.92,11,11s-4.92,11-11,11Z" />
      <path d="M111.62,261h-24.62c-6.08,0-11-4.92-11-11s4.92-11,11-11h24.62c6.08,0,11,4.92,11,11s-4.92,11-11,11Z" />
      <path d="M365.26,376.26c-2.82,0-5.63-1.07-7.78-3.22l-17.41-17.41c-4.3-4.3-4.3-11.26,0-15.56,4.29-4.3,11.26-4.3,15.56,0l17.41,17.41c4.3,4.3,4.3,11.26,0,15.56-2.15,2.15-4.96,3.22-7.78,3.22Z" />
      <path d="M152.15,163.15c-2.82,0-5.63-1.07-7.78-3.22l-17.41-17.41c-4.3-4.3-4.3-11.26,0-15.56,4.29-4.3,11.26-4.3,15.56,0l17.41,17.41c4.3,4.3,4.3,11.26,0,15.56-2.15,2.15-4.96,3.22-7.78,3.22Z" />
    </svg>
  );
}
